var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPin = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 34",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 .333A11.658 11.658 0 0 0 .333 12C.333 20.75 12 33.667 12 33.667S23.666 20.75 23.666 12C23.666 5.55 18.45.333 12 .333Zm0 15.834A4.168 4.168 0 0 1 7.833 12C7.833 9.7 9.7 7.833 12 7.833S16.166 9.7 16.166 12 14.3 16.167 12 16.167Z"
})));
export default SvgPin;